import { getClassHasEnded } from '@lingoda/classes-helpers';
import { instantDate } from '@lingoda/dates';
import type { ExistingClassData, GeneratedClassData } from '../types';

type ClassParams =
    | Pick<ExistingClassData, 'isExisting' | 'isForNewClassroom' | 'endDate'>
    | Pick<GeneratedClassData, 'isExisting' | 'endDate'>;

export const getIsClassroomAlertForClassVisible = (classItem: ClassParams) => {
    const hasEnded = getClassHasEnded(instantDate(classItem.endDate), new Date());
    const isNewClassroomPromoBannerVisible =
        classItem.isExisting && classItem.isForNewClassroom && !hasEnded;

    return isNewClassroomPromoBannerVisible;
};
